module.exports = __webpack_public_path__ + "img/Font 12.0deca44c.jpg";